/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import {  payInfoList, getBranchList } from '@/api/common'
import { getCustomerNameListByFinanceBackMoneyMainPart, getFinanceOrderListByCustomerIdOrMarketCooperationId, setFinanceRefund, getFinanceRefundById, setFinanceRefundById, setPayeeInfo } from '@/api/financial-center'
import { formatDate } from '@/utils/timeFilter'
import { getDraftById, setDraftById } from '@/api/draft'
import { StudentInfo, ParnterInfo, OrderInfo } from './interface'

import { delNullProperty } from '@/utils'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class NewRefund extends Vue {
    orderList = []
    tableKey = Math.random()
    page = 1
    tableRandom = Math.random()
    customerNameOrMarketCooperationName = ''
    draftId = NaN
    refundId = NaN
    financeRefundLogList = []
    disabledButton = false
    logShow = true

    formData = {
        types: '', // 0-退款退项  1-退款不退项
        main: '0', // 0-学生。1-合作伙伴
        account: '暂不使用',
        refundPrice: '',
        refundDate: new Date(),
        refundCause: '',
        directorUserId: '',
        deparment: '',
        deparmentId: '',
        oldRefundPrice: '',
        // mainPartName:'' // 合作伙伴或者学生名称
        studentmainPartName:'' ,// 学生名称
        parntermainPartName:'' ,// 合作伙伴名称
        directorUserName:'', // 合作伙伴名称
    }
    editUserName = '' // 创建人的userName，编辑的时候会有值，新建的时候用计算属性userName
    editCreatedAt = '' // 创建时间，也是在编辑的时候使用
    fileList = []

    saveDraftDialogShow = false
    reviewErrorDialogShow = false
    checkingDataErrorDialogShow = false
    isDraft = '0'
    limit = 20
    studentDialog = false
    studentDialogInputValue = ''
    studentDialogInputTotal: number = null
    studentDialogTaleData = []
    studentDialogTotal = 0
    studentDialogPage = 1
    studentDialogTableLoading = false
    studentDialogSelect: StudentInfo = null
    studentConfirmList: StudentInfo = null
    studentInfo: StudentInfo = {
        customerCreatedAt: '',
        customerDirectorUserName: '',
        customerGrade: '',
        customerId: null,
        customerName: '',
        customerPhone: '',
        customerSource: '',
        customerSourceName: '',
        customerSpecialized: '',
        customerType: '',
        customerWeChat: '',
    }

    orderDialog = false
    orderDialogInputValue = ''
    orderDialogInputTotal = null
    orderDialogTaleData = []
    orderDialogTotal = 0
    orderDialogPage = 1
    orderDialogTableLoading = false
    orderDialogSelect: OrderInfo = null
    orderConfirmList: OrderInfo = null
    orderInfo: OrderInfo = {
        backMoney: NaN,
        code: '',
        customerName: '',
        directorUserRealName: '',
        id: NaN,
        needBackMoney: NaN,
        price: '',
        refundSum: NaN,
        souCourseName: '',
        souCourseSchoolBegin: ''
    }

    parnterDialog = false
    parnterDialogInputValue = ''
    parnterDialogInputTotal: number = null
    parnterDialogTaleData = []
    parnterDialogTotal = 0
    parnterDialogPage = 1
    parnterDialogTableLoading = false
    parnterDialogSelect: ParnterInfo = null
    parnterConfirmList: ParnterInfo = null
    parnterInfo: ParnterInfo = {
        marketCooperationCreatedAt: '',
        marketCooperationDirectorUserId: '',
        marketCooperationId: NaN,
        marketCooperationName: '',
        marketCooperationTypes: '',
        marketCooperationAccount : {}
    }

    isUpdatedData = '0'
    newAccountDialog = false //新增收款账户
    payInfo: any = {
        name: '',
        cardNum: '',
        branch: '',
        type: '',
        page: 1,
        limit: 20,
        id: '',
    }
    accountTypeList = [
        {value: 'PUBLIC', label: '对公账户'},
        {value: 'PERSONAL', label: '个人账户'},
    ]
    type = '' //账户类型
    name = '' //开户名称
    cardNum = '' //银行卡号
    branch = '' //开户网点
    phoneNo = '' //手机号
    certificateNo = '' // 身份证号
    payeeInfoId = '' //新建返佣需要
    payInfoLoading = false
    payeeInfoList = [] // 开户名称数据
    total: 0
    searchName: any =null //开户名称
    searchCardName: any =null //银行卡号
    searchBranchName: any = null //开户网点
    branchInfoList = [] // 开户网点数据
    branchPage = 1
    branchLimit = 20
    formRule = {
        types: [{required: true, message: '请选择退款类型', trigger: ['blur','change']}],
        refundDate: [{ required: true, message: '请选择期待退款时间', trigger: 'change' }],
        refundCause: [{ required: true, message: '请输入退款原因', trigger: 'blur' }],
        refundPrice: [{ required: true, message: '请输入本次退款金额', trigger: 'blur' }],
        main: [{required: true, message: '请选择退款主体', trigger: 'change'}],
        // account: [{required: true, message: `请输入${this.formData.main === '1' ? '合作伙伴' : '学生'}退款账户`, trigger: 'blur'}],
        parntermainPartName: [{required: true, message: '请选择合作伙伴名称', trigger: ['blur', 'change']}],
        studentmainPartName: [{required: true, message: '请选择学生名称', trigger: ['blur', 'change']}],
        name: [{ required: true, message: '请选择开户名称', trigger: 'change' }],
        cardNum: [{ required: true, message: '请选择银行卡号', trigger: 'change' }],
    }
    accountEditBtn = false
    orderDialogLimit = 20
    tableLoading = false
    fileList1 = []
    previewVisible = false
    previewPath = ''
    previewName = ''
    timer = null
    timerNew = null
    timerNew1 = null
    // isReadonly = false
    syncDialogVisible = false
    msg = ''
    loading = false
    uploadData = {
        bucket: 'crm',
        signature: ''
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    get userName() {
        return UserModule.userName
    }

    get deparment() {
        return UserModule.department
    }

    get directorUserId() {
        return UserModule.userId
    }

    get studentOrParnterLimit() {
        let limit = 20
        if (this.formData.main === '1') {
            this.parnterDialogInputValue && (limit = this.parnterDialogTotal)
        } else {
            this.studentDialogInputValue && (limit = this.studentDialogTotal)
        }
        return limit
    }
    get elImageUrls() {
        if(this.fileList1 && this.fileList1.length > 0){
            return this.fileList1.map(item => item.url)
        }
    }
    created() {
        if(this.$route.query.isUpdatedData) {
            this.isUpdatedData = this.$route.query.isUpdatedData as string
        }

        if (this.$route.query.refundId) {
            this.refundId = Number(this.$route.query.refundId)
            this.getFinanceRefundById()
        }

        if (this.$route.query.draftId) {
            this.draftId = Number(this.$route.query.draftId)
            this.getDraftById()
        }
    }
    formatDate = formatDate

    beforeUpload (file) {
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    async getCustomerNameListByFinanceBackMoneyMainPart() {
        this.studentDialogTableLoading = true
        this.parnterDialogTableLoading = true


        const obj = {
            mainPart: this.formData.main,
            page: this.formData.main == '0'?this.studentDialogPage:this.formData.main == '1' ? this.parnterDialogPage:1,
            limit: this.limit,
            customerNameOrMarketCooperationName:this.customerNameOrMarketCooperationName,
        }
        const data = await getCustomerNameListByFinanceBackMoneyMainPart(delNullProperty(obj)) as unknown as { allNum: number; customerOrMarketCooperationList: any[] }
        const { allNum, customerOrMarketCooperationList } = data
        if (this.formData.main == '0') {
            this.studentDialogTaleData = customerOrMarketCooperationList
            this.studentDialogTotal = allNum
            this.studentDialogTableLoading = false
            // this.isReadonly = false
        }
        if (this.formData.main == '1') {
            this.parnterDialogTaleData = customerOrMarketCooperationList
            this.parnterDialogTotal = allNum
            this.parnterDialogTableLoading = false
            // this.isReadonly = false
        }
        this.tableRandom = Math.random()


    }

    getRowKeys (row) {
        return `${row.customerId}${row.customerType}`
    }



    async getFinanceOrderListByCustomerIdOrMarketCooperationId() {
        this.tableLoading = true

        // 发请求拿到数据并暂存全部数据
        this.orderDialogTableLoading = true
        let obj: {
            mainPart: string;
            customerId?: number;
            customerType?: string;
            customerName?: string;
            marketCooperationId?: number;
            limit: number;
            page: number;
        } = null
        if (this.formData.main === '1') {
            obj = {
                mainPart: this.formData.main,
                marketCooperationId: this.parnterDialogSelect.marketCooperationId,
                limit: this.orderDialogLimit,
                page: this.orderDialogPage,
                customerName: this.orderDialogInputValue,
            }
        } else {
            obj = {
                mainPart: this.formData.main,
                customerId: this.studentDialogSelect.customerId,
                customerType: this.studentDialogSelect.customerType,
                page: this.orderDialogPage,
                limit:  this.orderDialogLimit,
                customerName: this.orderDialogInputValue
            }
        }

        const data: any = await getFinanceOrderListByCustomerIdOrMarketCooperationId(delNullProperty(obj))
        this.orderDialogTaleData = data.financeOrderList
        this.tableKey = Math.random()
        this.orderDialogTotal =  data.allNum
        this.orderDialogTableLoading = false
        this.tableLoading =false
        // this.isReadonly =false
    }

    handleCurrentChange(val) {
        this.orderDialogPage = val
        this.getFinanceOrderListByCustomerIdOrMarketCooperationId()
    }

    handleSizeChange(val) {
        this.orderDialogLimit = val
        this.getFinanceOrderListByCustomerIdOrMarketCooperationId()
    }

    // getList() {
    //     //  es6过滤得到满足搜索条件的展示数据list
    //     const list = this.orderList.filter((item, index) =>
    //         item.customerName.includes(this.orderDialogInputValue)
    //     )
    //     //过滤分页
    //     this.orderDialogTaleData = list.filter((item, index) =>
    //         index < this.orderDialogPage * this.limit && index >= this.limit * (this.orderDialogPage - 1)
    //     )
    //     //分页的总数据
    //     this.orderDialogTotal = list.length
    //     // this.setCheckedRows() //回显已勾选的数据
    // }

    // async directorUserIdChange(val) {
    //     const selectedItem = this.userList.find(item => item.id === val);
    //     this.formData.deparment = selectedItem.departmentName
    // }

    async getFinanceRefundById() {
        const obj = {
            id: this.refundId,
            isUpdatedData: this.isUpdatedData,
        }
        const data = await getFinanceRefundById(obj) as unknown as { financeRefund: any }
        this.formData.main = data.financeRefund.mainPart === '合作伙伴' ? '1' : '0'
        this.formData.types = data.financeRefund.types == '0' ? '退款退项' : '退款不退项'
        this.formData.account = data.financeRefund.account
        this.formData.refundPrice = data.financeRefund.price
        this.formData.oldRefundPrice = data.financeRefund.price
        this.formData.refundCause = data.financeRefund.refundCause
        this.formData.refundDate = data.financeRefund.refundAt
        this.formData.directorUserId = data.financeRefund.directorUserId
        this.formData.directorUserName = data.financeRefund.directorUserRealName
        this.formData.deparment = data.financeRefund.directorDepartmentlName
        this.formData.deparmentId = data.financeRefund.directorDepartmentlId
        this.editCreatedAt = data.financeRefund.createdAt
        this.editUserName = data.financeRefund.createdUserRealName
        if (this.formData.main === '1') {
        //     // this.parnterInfo.marketCooperationName = data.financeRefund.mainPartName
            this.formData.parntermainPartName = data.financeRefund.mainPartName
        } else {
        // this.studentInfo.customerName = data.financeRefund.mainPartName
        this.formData.studentmainPartName = data.financeRefund.mainPartName
        }
        this.orderInfo.souCourseName = data.financeRefund.souCourseName
        this.orderInfo.souCourseSchoolBegin = formatDate('yyyy-MM-dd', new Date(data.financeRefund.souCourseSchoolBegin))
        this.orderInfo.code = data.financeRefund.financeOrderCode
        this.orderInfo.backMoney = data.financeRefund.backMoneySum
        this.orderInfo.price = data.financeRefund.financeOrderPrice
        this.orderInfo.refundSum = data.financeRefund.refundSum
        this.financeRefundLogList = data.financeRefund.financeRefundLogList
        this.fileList = data.financeRefund.financeRefundProofList
        this.fileList1 = data.financeRefund.financeRefundProofList

        this.orderDialogSelect = this.orderInfo
        if(data.financeRefund.financeRefundAccount){
            this.payInfo = data.financeRefund.financeRefundAccount
            this.payInfo.id= data.financeRefund.financeRefundAccount.payeeInfoId
            this.accountEditBtn = true
            // 0=>未打款; 1=>打款中; 2=>已打款
            if(data.financeRefund.financeRefundAccount.status == '0'){
                return this.payInfo.status = '未打款'
            }else if(data.financeRefund.financeRefundAccount.status == '1'){
                return this.payInfo.status = '打款中'
            }else if(data.financeRefund.financeRefundAccount.status == '2'){
                return this.payInfo.status = '已打款'
            }else if(data.financeRefund.financeRefundAccount.status == '3'){
                return this.payInfo.status = '同步失败'
            }
        }
    }

    async getDraftById() {
        const { result } = await getDraftById(this.draftId) as unknown as { result }
        this.formData.main = result.mainPart === '合作伙伴' ? '1' : '0'
        this.formData.types = result.types === '0' ? '退款退项' : '退款不退项'
        this.formData.account = result.account
        this.formData.refundPrice = result.price
        this.formData.refundCause = result.refundCause
        this.formData.refundDate = result.refundAt
        this.formData.directorUserId = result.directorUserId
        this.formData.deparment = result.directorDepartmentlName
        this.formData.deparmentId = result.directorDepartmentlId
        this.editCreatedAt = result.createdAt
        this.editUserName = result.createdUserRealName
        this.payInfo = result.financeRefundAccount ? result.financeRefundAccount : {} //收款账户信息
        this.fileList = result.financeRefundProofList
        if (this.formData.main === '1') {
        //     // this.parnterInfo.marketCooperationName = result.mainPartName
            this.formData.parntermainPartName = result.mainPartName
        } else {
        // this.studentInfo.customerName = result.mainPartName
        this.formData.studentmainPartName = result.mainPartName
        }
        this.orderInfo.souCourseName = result.souCourseName
        this.orderInfo.souCourseSchoolBegin = formatDate('yyyy-MM-dd', new Date(result.souCourseSchoolBegin))
        this.orderInfo.code = result.financeOrderCode
        this.orderInfo.backMoney = result.backMoneySum
        this.orderInfo.price = result.financeOrderPrice
        this.orderInfo.refundSum = result.refundSum
        this.financeRefundLogList = result.financeRefundLogList
        this.orderDialogSelect = this.orderInfo

        if(result.financeRefundAccount){
            this.payInfo = result.financeRefundAccount
            this.accountEditBtn = true
            // 0=>未打款; 1=>打款中; 2=>已打款
            if(result.financeRefundAccount.status == '0'){
                return this.payInfo.status = '未打款'
            }else if(result.financeRefundAccount.status == '1'){
                return this.payInfo.status = '打款中'
            }else if(result.financeRefundAccount.status == '2'){
                return this.payInfo.status = '已打款'
            }else if(result.financeRefundAccount.status == '3'){
                return this.payInfo.status = '同步失败'
            }
        }
    }

    studentInputFocus(e) {
        this.studentDialog = true
        // this.studentDialogSelect.customerId = null

        // this.studentDialogSelect.customerType = ""
        this.customerNameOrMarketCooperationName = ''
        this.studentDialogPage = 1
        this.studentDialogInputValue = ''
        e.target.blur()
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }

    orderInputFocus(e) {
        if (!this.studentDialogSelect && !this.parnterDialogSelect) { this.$message.error('请选择学生或者合作伙伴'); e.target.blur(); return }
        this.orderDialog = true
        this.orderDialogPage = 1
        this.orderDialogInputValue = ''
        this.getFinanceOrderListByCustomerIdOrMarketCooperationId()
        e.target.blur()
    }

    parnterInputFocus(e) {
        this.customerNameOrMarketCooperationName = ''
        this.parnterDialog = true
        this.parnterDialogPage = 1
        this.parnterDialogInputValue = ''
        e.target.blur()
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }

    /*  学生弹框相关事件  */
    clickStudentDialogFilter() {
        if (this.timerNew !== null) clearTimeout(this.timerNew)
        this.timerNew = setTimeout(() => {
            this.studentDialogPage = 1
            this.customerNameOrMarketCooperationName = this.studentDialogInputValue
            this.getCustomerNameListByFinanceBackMoneyMainPart()
        }, 1000)
    }
    // 学生列表取消
    handleStudentDialog(){
        let id = null
        let type = null
        this.studentDialog = false
        if(this.studentConfirmList){
            id = this.studentConfirmList.customerId != this.studentDialogSelect.customerId
            type = this.studentConfirmList.customerType != this.studentDialogSelect.customerType
        }

        if(!this.studentConfirmList || id){
            const studentTable = this.$refs.studentDialogTable as HTMLFormElement
            studentTable.clearSelection()
            studentTable.toggleRowSelection(this.studentConfirmList,true)
        }
        if(this.studentDialogSelect){
            const studentTable = this.$refs.studentDialogTable as HTMLFormElement
            studentTable.toggleRowSelection(this.studentDialogSelect,true)
        }
    }
    studentDialogConfirm() {
        this.studentConfirmList = this.studentDialogSelect
        this.studentDialog = false
        if(this.studentInfo.customerId === this.studentDialogSelect.customerId) return
        this.formData.account = '暂不使用'
        this.formData.refundPrice = ''
        this.formData.refundCause = ''
        this.formData.refundDate = new Date()
        this.studentInfo = JSON.parse(JSON.stringify(this.studentDialogSelect))
        this.formData.studentmainPartName = this.studentInfo.customerName


        for(const key in this.orderInfo) {
            this.orderInfo[key] = ''
        }
    }

    studentDialogSelectionChange(selectionArr) {
        if (selectionArr.length > 0) {
            this.studentDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            if (selectionArr.length > 1) {
                const studentTable = this.$refs.studentDialogTable as HTMLFormElement
                studentTable.clearSelection()
                studentTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for (const key in this.studentDialogSelect) {
                this.studentDialogSelect[key] = null
            }
        }
    }

    studentDialogPageChange(page: number) {
        this.studentDialogPage = page
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }
    pageSizeChange(limit: number) {
        this.studentDialogTotal = limit
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }
    /*  订单弹框相关事件  */
    clickOrderDialogFilter(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.orderDialogPage = page
            this.getFinanceOrderListByCustomerIdOrMarketCooperationId()
        }, 1000)
    }
    // 合作伙伴列表取消
    handleOrderDialog(){
        this.orderDialog = false
        this.orderDialogInputValue = ''
        // this.studentDialogSelect.customerId = null
        // this.studentDialogSelect.customerType = ""
        this.orderDialogPage = 1
        if(!this.orderConfirmList || (this.orderConfirmList.id != this.orderDialogSelect.id)){
            const orderTable = this.$refs.orderDialogTable as HTMLFormElement
            orderTable.clearSelection()
            orderTable.toggleRowSelection(this.orderConfirmList,true)
        }
        if(this.orderDialogSelect){
            const orderTable = this.$refs.orderDialogTable as HTMLFormElement
            orderTable.toggleRowSelection(this.orderDialogSelect,true)
        }

    }
    orderDialogConfirm() {
        this.orderDialog = false
        if(this.orderInfo.id === this.orderDialogSelect.id) return
        this.formData.refundPrice = ''
        this.formData.refundCause = ''
        this.formData.refundDate = new Date()
        this.orderInfo = JSON.parse(JSON.stringify(this.orderDialogSelect))
        this.orderConfirmList = this.orderDialogSelect  //存数据取消选中状态
    }

    orderDialogSelectionChange(selectionArr) {
        if (selectionArr.length > 0) {
            this.orderDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            if (selectionArr.length > 1) {
                const orderTable = this.$refs.orderDialogTable as HTMLFormElement
                orderTable.clearSelection()
                orderTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for (const key in this.orderDialogSelect) {
                this.orderDialogSelect[key] = null
            }
        }
    }
    //
    // orderDialogPageChange(page: number) {
    //     this.orderDialogPage = page
    //     this.getList()
    // }

    orderDialogTableSelect(row) {
        // 当前订单是否可以选择
        return row.backMoney - row.refundSum > 0
    }

    /*  合作伙伴弹框相关事件  */
    pageChangePartner(page: number) {
        if (this.timerNew1 !== null) clearTimeout(this.timerNew1)
        this.timerNew1 = setTimeout(() => {
            this.parnterDialogPage = page
            this.customerNameOrMarketCooperationName = this.parnterDialogInputValue
            this.getCustomerNameListByFinanceBackMoneyMainPart()
        }, 1000)
    }
    // clickParnterDialogFilter() {
    //     if (this.timerNew1 !== null) clearTimeout(this.timerNew1)
    //     this.timerNew1 = setTimeout(() => {
    //         this.parnterDialogPage = 1
    //         this.customerNameOrMarketCooperationName = this.parnterDialogInputValue
    //         this.getCustomerNameListByFinanceBackMoneyMainPart()
    //     }, 1000)
    // }
    // 合作伙伴列表取消
    handleParnterDialog(){
        this.parnterDialog = false
        if(!this.parnterConfirmList || (this.parnterConfirmList.marketCooperationId != this.parnterDialogSelect.marketCooperationId)){
            const parnterTable = this.$refs.parnterDialogTable as HTMLFormElement
            parnterTable.clearSelection()
            parnterTable.toggleRowSelection(this.parnterConfirmList,true)
        }
        if(this.parnterDialogSelect){
            const parnterTable = this.$refs.parnterDialogTable as HTMLFormElement
            parnterTable.toggleRowSelection(this.parnterDialogSelect,true)
        }

    }
    parnterDialogConfirm() {
        this.parnterDialog = false
        if(this.parnterInfo.marketCooperationId === this.parnterDialogSelect.marketCooperationId) return
        this.formData.account = '暂不使用'
        this.formData.refundPrice = ''
        this.formData.refundCause = ''
        this.formData.refundDate = new Date()
        this.parnterInfo = JSON.parse(JSON.stringify(this.parnterDialogSelect))
        this.formData.parntermainPartName = this.parnterInfo.marketCooperationName
        for(const key in this.orderInfo) {
            this.orderInfo[key] = ''
        }
        this.payInfo = {
            ...this.parnterInfo.marketCooperationAccount,
        }
        this.payInfo.type = this.payInfo.types === '0' ? '对公账户' : this.payInfo.types === '1' ? '个人账户' : ''
        this.payInfo.id = this.payInfo.payeeInfoId
        if (!this.payInfo.id) {
            const obj = {}
            for (const key in this.payInfo) {
                if (key !== 'type' && key !== 'types' && key !== 'certificateNo' && key !== 'phoneNo') {
                    obj[key] = this.payInfo[key]
                }
            }
            /*其余项也都为空*/
            if (!Object.values(obj).every(item => !item)) {
                this.$message.error('请重新选择收款账户')
                return
            }
        }
        this.parnterConfirmList = this.parnterDialogSelect
    }

    parnterDialogSelectionChange(selectionArr) {
        if (selectionArr.length > 0) {
            this.parnterDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            if (selectionArr.length > 1) {
                const parnterTable = this.$refs.parnterDialogTable as HTMLFormElement
                parnterTable.clearSelection()
                parnterTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for (const key in this.parnterDialogSelect) {
                this.parnterDialogSelect[key] = null
            }
        }
    }

    parnterDialogPageChange(page: number) {
        this.parnterDialogPage = page
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }
    partnerPageSizeChange(limit: number) {
        this.parnterDialogTotal = limit
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }


    clickSaveDraftButton() {
        if (this.checkingDataErrorDialogShow) this.checkingDataErrorDialogShow = false
        this.saveDraftDialogShow = true
        this.isDraft = '1'
    }
    saveDraftDialogCancel() {
        this.saveDraftDialogShow = false
        this.isDraft = '0'
    }

    clickSubmitButton() {
        // if(!this.formData.types) { this.$message.error('请选择退款类型'); return }
        // if(this.formData.main === '0') {
        //     // if(!this.studentInfo.customerName) { this.$message.error('请选择学生名称'); return }
        //     if(!this.formData.mainPartName ) { this.$message.error('请选择学生名称'); return }
        // } else {
        // if(!this.parnterInfo.marketCooperationName) { this.$message.error('请选择合作伙伴名称'); return }
        // if (!this.formData.mainPartName) {
        //     this.$message.error('请选择合作伙伴名称');
        //     return
        // }
        // }
        // if(!this.formData.types) { this.$message.error('请选择退款类型'); return }

        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false;
            }
        });

        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false;
            }
        })

        if (!this.orderInfo.souCourseName) {
            this.$message.error('请选择订单');
            return
        }
        // if(!this.formData.account) { this.$message.error('退款账户不可为空'); return }
        // if(!this.formData.refundPrice && this.formData.refundPrice != '0') { this.$message.error('本次退款金额不可为空'); return }
        // if(!this.formData.refundDate) { this.$message.error('退款时间不可为空'); return }
        // if(!this.formData.refundCause) { this.$message.error('退款原因不可为空'); return }
        if (!this.formData.directorUserId) {
            this.$message.error('负责人不可为空');
            return
        }
        if (!this.payInfo.id) {
            this.$message.error('请重新选择收款账户')
            return;
        }
        if (!this.payInfo.name || !this.payInfo.cardNum) {
            this.$message.error('请将收款信息填写完整')
            return
        }

        if (this.refundId) {
            if (Number(this.formData.refundPrice) > this.orderInfo.backMoney - this.orderInfo.refundSum + Number(this.formData.oldRefundPrice)) {
                this.$message.error('本次退款金额不能大于剩余退款金额')
                return
            }
        } else {
            if (Number(this.formData.refundPrice) > this.orderInfo.backMoney - this.orderInfo.refundSum) {
                this.$message.error('本次退款金额不能大于剩余退款金额')
                return
            }
        }

        const obj = {
            types: this.formData.types,
            mainPart: this.formData.main,
            customerId: this.studentInfo.customerId,
            customerType: this.studentInfo.customerType,
            marketCooperationId: this.parnterInfo.marketCooperationId,
            account: this.formData.account,
            financeOrderId: this.orderInfo.id,
            price: this.formData.refundPrice,
            refundAt: formatDate('yyyy-MM-dd', new Date(this.formData.refundDate)),
            refundCause: this.formData.refundCause,
            directorUserId: this.formData.directorUserId,
            isDraft: this.isDraft,
            payeeInfoId: this.payInfo.id, //易快报收款账户id
            financeRefundProofList: this.fileList
        }
        if (this.formData.main === '1') {
            delete obj.customerId
            delete obj.customerType
        } else {
            delete obj.marketCooperationId
        }
        if (this.refundId) {
            this.editRefundSubmit();
            return
        }
        if (flag) {
            this.disabledButton = true
            this.loading = true
            setFinanceRefund(delNullProperty(obj)).then(() => {
                if (this.isDraft === '1') {
                    this.$message.success('退款已成功保存到草稿箱')
                } else {
                    this.$message.success("新建退款成功")
                }
                this.loading = false
                setTimeout(() => {
                    this.closePage()
                }, 1500)

            }).catch((err: Error) => {
                if (err) {
                    this.disabledButton = false
                    this.loading=  false
                }
                if (err.message === '审批流报错') {
                    this.reviewErrorDialogShow = true
                }
                if (err.message === '订单未成功退项') {
                    this.checkingDataErrorDialogShow = true
                }
            })
        }
    }

    async editRefundSubmit() {
        if (!this.payInfo.name ||  !this.payInfo.cardNum) {
            this.$message.error('请将收款信息填写完整')
            return
        }
        const obj = {
            id: this.refundId,
            account: this.formData.account,
            price: this.formData.refundPrice,
            refundAt: this.formatDate('yyyy-MM-dd', new Date(this.formData.refundDate)),
            refundCause: this.formData.refundCause,
            directorUserId: this.formData.directorUserId,
            payeeInfoId: this.payInfo.id ? this.payInfo.id : this.payInfo.payeeInfoId ? this.payInfo.payeeInfoId : '', //易快报收款账户id
            financeRefundProofList: this.fileList
        }
        this.disabledButton = true
        setFinanceRefundById(obj).then(() => {
            this.$message.success("编辑退款成功")
            setTimeout(() => {
                this.closePage()
            }, 1500)
        }).catch((err: Error) => {
            if (err.message === '审批流报错') {
                this.reviewErrorDialogShow = true
            }
            this.disabledButton = false
        })
    }

    clickEditSaveButton(type: string) {
        if (!this.payInfo.name ||  !this.payInfo.cardNum) {
            this.$message.error('请将收款信息填写完整')
            return
        }
        const obj = {
            types:this.formData.types,
            mainPart: this.formData.main,
            customerId: this.studentInfo.customerId,
            customerType: this.studentInfo.customerType,
            marketCooperationId: this.parnterInfo.marketCooperationId,
            account: this.formData.account,
            financeOrderId: this.orderDialogSelect.id,
            price: this.formData.refundPrice,
            refundAt: formatDate('yyyy-MM-dd', new Date(this.formData.refundDate)),
            refundCause: this.formData.refundCause,
            directorUserId: this.formData.directorUserId,
            payeeInfoId: this.payInfo.id ? this.payInfo.id : this.payInfo.payeeInfoId ? this.payInfo.payeeInfoId : '', //易快报收款账户id
            financeRefundProofList: this.fileList
        }

        if (this.formData.main === '1') {
            delete obj.customerId
            delete obj.customerType
        } else if(this.formData.main === '0'){
            delete obj.marketCooperationId
        }
        this.disabledButton = true
        this.loading = true
        setDraftById({
            id: this.draftId,
            form: obj,
            isSubmit: type
        }).then(res => {
            this.$message.success(`草稿${type === '0' ? '保存' : '提交'}成功`)
            this.loading = false
            setTimeout(() => { this.closePage() }, 1500)
        }).catch((err: Error) => {
            if (err.message === '审批流报错') {
                this.reviewErrorDialogShow = true
            }
            this.disabledButton = false
            this.loading=  false
        })
    }

    // 主题改变时清空已选中的 客户信息和订单信息
    mainChange(val: string) {
        if (val === '1') {
            for (const key in this.studentInfo) {
                this.studentInfo[key] = null
            }
            this.parnterDialogPage = 1
            this.formData.account = '暂不使用'
            this.formData.parntermainPartName = ''
        }
        if (val === '0') {
            for (const key in this.parnterInfo) {
                this.parnterInfo[key] = null
            }
            this.studentDialogPage = 1
            this.formData.account = '暂不使用'
            this.formData.studentmainPartName = ''
        }
        for (const key in this.orderInfo) {
            this.orderInfo[key] = null
        }
        this.formData.refundPrice = ''
        this.customerNameOrMarketCooperationName = ''
    }

    // 点击表格行的时候选中该条数据
    clickStudentDialogTableRow(row) {
        (this.$refs.studentDialogTable as HTMLFormElement).toggleRowSelection(row)
    }

    clickOrderDialogTableRow(row) {
        if(row.backMoney - row.refundSum <= 0) return
        (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
    }

    clickParnterDialogTableRow(row) {
        (this.$refs.parnterDialogTable as HTMLFormElement).toggleRowSelection(row)
    }

    uploadSuccess(response, file, fileList) {
        // const { data } = res
        // this.$message.success('上传成功')
        // this.fileList.push({ name: data.name, url: data.ossUrl })
        if (fileList.every(item => item.status == 'success')) {
            this.fileList = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.$message.success('上传成功');
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    closePage() { window.close() }
    // 开户网点
    async getBranchList() {
        let objs = {
            name: this.searchBranchName,
            page: this.branchPage,
            limit: this.branchLimit,
        }
        const data: any = await getBranchList(delNullProperty(objs))
        this.branchInfoList = [...this.branchInfoList, ...data.branchList]
        let result = []
        let obj = {}
        for(let i =0; i<this.branchInfoList.length; i++){
            if(!obj[this.branchInfoList[i].name]){
                result.push(this.branchInfoList[i]);
                obj[this.branchInfoList[i].name] = true;
            }
        }
        this.branchInfoList = result
    }
    // 新增账户打开弹窗
    clickNewAccount(){
        this.newAccountDialog = true
        this.getBranchList(); //开户网点
    }
    async handleBranchInfo(){
        if((this.branchInfoList.length == 0 || !this.searchBranchName) && !this.branch){
            this.searchBranchName = null
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.searchBranchName })
            this.branchInfoList = result.branchList
        }
        if(this.branch){
            this.branchInfoList = []
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.branch })
            this.branchInfoList = result.branchList
        }
    }
    async handleRemoteBranch (query: any) {
        this.searchBranchName = query.trim();
        this.branchPage = 1
        this.branchLimit = 20
        if (query !== '') {
            const result: any = await getBranchList({page: this.branchPage,  name: query })
            this.branchInfoList = result.branchList
        } else {
          this.branchInfoList = []
          this.getBranchList();
        }
    }
    handleBranchLoadmore() {
        this.branchPage ++
        this.getBranchList();
    }
    handleClearBranch() {
        this.searchBranchName = null
        this.branch = ''
        this.branchPage = 1
        this.getBranchList()
    }
    handleBranchChange (val) {
        this.branch = val
    }

    // 开户名称列表
    async payInfoList() {
        let objs = {
            name: this.searchName,
            cardNum: this.searchCardName,
            page: this.payInfo.page,
            limit: this.payInfo.limit,
        }
        const data: any = await payInfoList(delNullProperty(objs))
        this.payeeInfoList = [...this.payeeInfoList, ...data.payeeInfoList]
        let result = []
        let obj = {}
        for(let i =0; i<this.payeeInfoList.length; i++){
            if(!obj[this.payeeInfoList[i].name]){
                result.push(this.payeeInfoList[i]);
                obj[this.payeeInfoList[i].name] = true;
            }
        }
        this.payeeInfoList = result
    }
    async handlePayInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchName) && !this.payInfo.name){
            this.searchName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.name){
            this.payeeInfoList = []
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
    }
    async handleRemotePayInfo (query: any) {
        this.searchName = query.trim();
        this.payInfo.page = 1
        this.payInfo.limit = 20
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page,  name: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
          this.payeeInfoList = []
            this.payInfoList();
        }
    }
    handlePayInfoLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }
    handleClearPayInfo() {
        this.searchName = null
        this.payInfo.cardNum = ''
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.payeeInfoId = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfoList()
    }
    // 开户名称
    handlePayInfoChange (indexVal) {
        this.msg = indexVal.message
        if(indexVal.message){
            this.syncDialogVisible = true
        }
        const indexId = indexVal.id
        let obj = this.payeeInfoList.find((item,index)=> item.id === indexId)
        this.payInfo.name = obj.name
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.payeeInfoId = obj.id
        // this.payInfo.pay = obj.id
        this.payInfo.type = obj.type
        this.payInfo.certificateNo = obj.certificateNo;
        this.payInfo.phoneNo = obj.phoneNo;
    }
    // 银行卡号
    async handlePayCardInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchCardName) && !this.payInfo.cardNum){
            this.searchCardName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.cardNum){
            this.payeeInfoList = []
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
    }
    async handleRemotePayCard (query: any) {
        this.searchCardName = query
        this.payInfo.page = 1
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
          this.payeeInfoList = []
            this.payInfoList();
        }
    }
    handlePayCardLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }
    handleClearPayCard() {
        this.payInfo.name = ''
        this.searchCardName = null
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfo.payeeInfoId = ''
        this.payInfoList()
    }
    // 银行卡号
    handlePayChangeCard (indexVal) {
        this.msg = indexVal.message
        if(indexVal.message){
            this.syncDialogVisible = true
        }
        const indexId = indexVal.id
        let obj = this.payeeInfoList.find((item,index)=> item.id === indexId)
        this.payInfo.name = obj.name
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.payeeInfoId = obj.id
        this.payInfo.type = obj.type
        this.payInfo.certificateNo = obj.certificateNo
        this.payInfo.phoneNo = obj.phoneNo

    }

    closeSyncDialog(){
        this.syncDialogVisible = false
    }

    changeType(val){
        this.certificateNo = ''
        this.phoneNo = ''
    }

    // 取消
    doCancel() {
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
        this.certificateNo = ''
        this.phoneNo = ''
        this.newAccountDialog = false
    }
    // 新增账户确认
    async handleConfirmAccount() {
        if (this.type === '' ||  this.name === ''|| this.cardNum === ''|| this.branch === '') {
            this.$message.error(`请将${this.type === '' ? '账户类型，' : ''}${this.name === '' ? '开户名称，' : ''}${this.cardNum === '' ? '银行卡号，' : ''}${this.branch === '' ? '开户网点，' : ''}填写完整`)
            return
        }
        // if((this.type === 'PERSONAL'&&this.certificateNo=='')|| (this.type === 'PERSONAL'&&this.phoneNo=='')){
        //     this.$message.error(`请将${this.certificateNo === '' ? '身份证号，' : ''}${this.phoneNo === '' ? '手机号，' : ''}填写完整`)
        //     return
        // }
        const obj = {
            type: this.type,
            name: this.name,
            cardNum: this.cardNum,
            branch: this.branch,
            certificateNo: '',
            phoneNo: '',
        }
        const { payeeInfoId } = await setPayeeInfo(delNullProperty(obj)) as unknown as { payeeInfoId: string}
        this.payInfo.id = payeeInfoId
        this.payInfo.name = this.name
        this.payInfo.cardNum = this.cardNum
        this.payInfo.branch = this.branch
        this.payInfo.certificateNo = this.certificateNo
        this.payInfo.phoneNo = this.phoneNo
        this.payInfo.type = this.type && this.type == 'PUBLIC' ? '对公账户' : this.type && this.type == 'PERSONAL' ? '个人账户': ''
        this.newAccountDialog = false
        /*清空所填值*/
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
    }

    judgeVal(value) {
        // console.log(value,'judgeVal');
        let val = (value && value.split("")) || [];
        let sNum = val.toString(); //先转换成字符串类型
        if (sNum.indexOf('.') === 0) {//第一位就是 .
            sNum = '0' + sNum
        }
        sNum = sNum.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符
        sNum = sNum.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的
        sNum = sNum.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        sNum = sNum.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        if(sNum.indexOf(".")< 0 && sNum !==""){
            sNum = parseFloat(sNum);
        }
        this.formData.refundPrice = sNum.toString();
    }


    changeDirectorUserId(e) {
        this.formData.directorUserId = e.id
        if (e.id) {
            this.formData.deparment = e.departmentName
        }
    }

    @Watch('directorUserId')
    handle(userId: string) {
        if(!this.formData.directorUserId){
            this.formData.directorUserId = userId
        }
    }

    @Watch('userName')
    handleDirectorUserName(userName: string) {
        if(!this.formData.directorUserName){
            this.formData.directorUserName = userName
        }
    }

    @Watch('deparment')
    handleChangeDeparment(deparment: string) {
        if (!this.formData.deparment) {
            this.formData.deparment = deparment
        }
    }
}
